import { AxiosStorage } from './storage';
export class BrowserAxiosStorage extends AxiosStorage {
    /**
     * @param storage Any browser storage, like sessionStorage or localStorage
     * @param prefix The key prefix to use on all keys.
     */
    constructor(storage, prefix = BrowserAxiosStorage.DEFAULT_KEY_PREFIX) {
        super();
        this.storage = storage;
        this.prefix = prefix;
        this.find = async (key) => {
            const json = this.storage.getItem(`${this.prefix}:${key}`);
            return json ? JSON.parse(json) : { state: 'empty' };
        };
        this.set = async (key, value) => {
            return this.storage.setItem(`${this.prefix}:${key}`, JSON.stringify(value));
        };
        this.remove = async (key) => {
            return this.storage.removeItem(`${this.prefix}:${key}`);
        };
    }
}
BrowserAxiosStorage.DEFAULT_KEY_PREFIX = 'a-c-i';
